import { RequestModalProps } from "components/RequestModals";
import {
  API_RESPONSE_BROKEN_VALIDATION_EXCEPTION_TYPE,
  BrokenRuleValidationError,
} from "services/apiErrors";
import FailureTryAgain from "./FailureTryAgain";
import FailureAcknowledge from "./FailureAcknowledge";

const RequestErrorModals = ({
  isOpen,
  onClose = () => {
    return;
  },
  error,
  onRetry,
  onReset,
  failureCount,
  customerName,
}: {
  customerName: string;
  error?: Error | BrokenRuleValidationError;
  onRetry: () => void;
  onReset?: () => void;
  failureCount: number;
} & RequestModalProps) => {
  if (!error) {
    return (
      <FailureTryAgain
        isOpen={isOpen}
        customerName={customerName}
        onClose={onClose}
        onRetry={onRetry}
        failureCount={failureCount}
      />
    );
  }
  if (
    Object.hasOwn(error, "Type") &&
    (error as BrokenRuleValidationError).Type ===
      API_RESPONSE_BROKEN_VALIDATION_EXCEPTION_TYPE
  ) {
    return (
      <FailureAcknowledge
        isOpen={isOpen}
        customerName={customerName}
        errorMsg={(error as BrokenRuleValidationError).Detail}
        onClose={onReset ?? onClose}
      />
    );
  } else if (error instanceof Error) {
    return (
      <FailureAcknowledge
        isOpen={isOpen}
        customerName={customerName}
        errorMsg={error.message}
        onClose={onReset ?? onClose}
      />
    );
  }

  return (
    <FailureAcknowledge
      isOpen={isOpen}
      customerName={customerName}
      errorMsg="Something went wrong"
      onClose={onReset ?? onClose}
    />
  );
};

export default RequestErrorModals;
